import * as React from "react";

const IconSearchKeyword: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 7"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#FFF" d="M6.941 5.308a.625.625 0 11-.883.883L4 4.134 1.942 6.191a.62.62 0 01-.884 0 .625.625 0 010-.884L3.117 3.25 1.058 1.19a.625.625 0 11.884-.884L4 2.367 6.059.308a.625.625 0 11.883.884L4.884 3.25 6.94 5.308z"/></svg>;
};

export default React.memo(IconSearchKeyword);
